import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { loadValidations } from "../../actions/loadValidations";
import CustomModal from "../Modal/CustomModal";
import { toast } from "react-toastify";
import { usePwaStatus } from "../CustomHooks/usePwaStatus";

function LoadValidations({ loadValidations, validation }) {
  const { loading } = validation;
  const [open, setOpen] = useState(false);
  const validationError = useSelector((state) => state.validation.error);
  const { requestPersistence } = usePwaStatus();

  useEffect(() => {
    // load the validations from the stores
    loadValidations();
  }, [loadValidations]);

  useEffect(() => {
    // controlling the modal message that allows the indexedDB to complete
    loading ? setOpen(true) : setOpen(false);
  }, [loading]);

  useEffect(() => {
    if (validationError.hasOwnProperty("idxDB")) {
      toast.error(`${validationError.idxDB}`, { autoClose: false });
    }
  }, [validationError]);

  useEffect(() => {
    requestPersistence();
  }, [requestPersistence]);

  return (
    <div>
      {loading && (
        <CustomModal
          modalStatus={open}
          modalTitle={"Application Update"}
          modalText={"Please Wait..."}
        />
      )}
      ;
    </div>
  );
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = {
  loadValidations,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadValidations);
